export default __webpack_public_path__ + "static/media/check-mark.2e56c0ce.svg";